<template>
  <div class="page-wrapper">
    <jump-header />
    <div class="special-top">
      <img class="poster-img" :src="specialDetail.pictureUrl" alt="" />
      <div class="special-detail">
        <div class="detail-intro text-line-1">{{ specialDetail.name }}</div>
<!--        <div class="detail-clicksum">-->
<!--          <img src="~@/assets/image/view.png" alt="" />-->
<!--          {{ specialDetail.clickSum }}-->
<!--        </div>-->
        <div class="detail-num">
          <img src="~@/assets/image/column.png" alt="" />
          {{ specialDetail.specialDetailNumber }}
        </div>
      </div>
    </div>
    <div class="special-list">
      <img class="square-img" src="~@/assets/image/square.png" alt="" />
      <div class="all-tag">全部</div>
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了~"
        @load="onLoad"
      >
        <div
          class="special-item"
          v-for="item in specialNewsList"
          :key="item.id"
          @click="toSpecialItem(item)"
        >
          <div class="item-left">
            <div class="news-title text-line-2">{{ item.operateName }}</div>
            <div class="news-info">
              <div class="news-tag">{{ item.newstagName }}</div>
              <span class="news-time">{{
                item.updateDate.substring(0, 16)
              }}</span>
            </div>
          </div>
          <img class="news-img" :src="item.pictureUrl" alt="" />
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import wxSdk from "@/http/wxApi.js";
import { useRoute } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import JumpHeader from "@/components/Base/JumpHeader";
import {
  querySpecialDetail,
  queryFCspecialDetailsBySpecialId,
} from "@/http/api";

export default defineComponent({
  name: "Special",
  components: {
    JumpHeader,
  },
  setup() {
    const route = useRoute();
    const specialId = ref(0);
    const loading = ref(false);
    const finished = ref(false);
    const specialDetail = ref({});
    const specialNewsList = ref([]);
    let page = 0;

    const getSpecialDetail = async () => {
      const { code, data } = await querySpecialDetail({
        id: specialId.value,
      });
      if (code === "1") {
        specialDetail.value = data;
        wxShare();
      }
    };

    const getFCSpecialDetail = async () => {
      const { code, data } = await queryFCspecialDetailsBySpecialId({
        specialId: specialId.value,
        rows: 20,
        page,
      });
      loading.value = false;
      if (code === "1") {
        specialNewsList.value = [...specialNewsList.value, ...data.pageList];
        if (data.totalPage <= page) {
          finished.value = true;
        }
      }
    };

    const toSpecialItem = (item) => {
      window.location.href = item.htmlUrl;
    };

    const wxShare = () => {
      const _specialDetail = specialDetail.value;
      const img = _specialDetail.shareCoverUrl
        ? _specialDetail.shareCoverUrl
        : "https://app.gztv.com/filedata/default/logo.jpg";
      wxSdk.getJSSDK({
        title: _specialDetail.name,
        desc: _specialDetail.intro,
        linkurl: `https://app.gztv.com/hcfmshare/#/Special?specialId=${specialId.value}`,
        img: img,
      });
    };

    const onLoad = () => {
      page++;
      getFCSpecialDetail();
    };

    onMounted(() => {
      specialId.value = route.query.specialId;
      getSpecialDetail();
      //getFCSpecialDetail();
    });

    return {
      loading,
      finished,
      specialDetail,
      specialNewsList,
      onLoad,
      toSpecialItem,
    };
  },
});
</script>

<style lang="scss" scoped>
.special-top {
  position: relative;
  width: 100%;
  margin: 0 auto;
  max-width: 450px;

  .poster-img {
    width: 100%;
    height: 300px;
  }

  .special-detail {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 60px;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 13px;

    .detail-intro {
      color: #fffefe;
      font-size: 14px;
      flex: 1;
      margin-right: 30px;
    }

    .detail-clicksum {
      display: flex;
      align-items: center;
      color: #fffefe;
      font-size: 14px;

      & > img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }

    .detail-num {
      display: flex;
      align-items: center;
      color: #fffefe;
      font-size: 14px;
      margin-left: 10px;

      & > img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }
    }
  }
}

.special-list {
  width: 100%;
  margin: 0 auto;
  max-width: 450px;

  .square-img {
    width: 100%;
    height: 13px;
    transform: translateY(-13px);
  }

  .all-tag {
    display: inline-block;
    padding: 8px 10px;
    border-radius: 12px;
    font-size: 14px;
    color: #fa3d70;
    background: #e6bac6;
    margin-left: 13px;
  }

  .special-item {
    display: flex;
    align-items: center;
    width: calc(100% - 26px);
    margin: 20px auto 0;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    border-radius: 8px;
    padding: 10px;
    box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.05);

    .item-left {
      display: flex;
      flex: 1;
      flex-direction: column;
      height: 100px;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 5px 0;
      margin-right: 10px;

      .news-title {
        font-weight: bold;
        font-size: 18px;
        color: #111;
        line-height: 22px;
      }

      .news-info {
        display: flex;
        align-items: center;

        .news-tag {
          display: inline-block;
          padding: 4px 8px;
          border-radius: 6px;
          color: #fff;
          font-size: 14px;
          background: rgba(250, 61, 112, 0.5);
        }

        .news-time {
          padding-left: 10px;
          font-size: 14px;
          color: #999;
        }
      }
    }

    .news-img {
      width: 100px;
      height: 100px;
      border-radius: 6px;
    }
  }
}
</style>
